import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../firebase/config";
import SpaceParticles from "../../components/Particles/SpaceParticles";
import { FaLock, FaEnvelope, FaExclamationCircle } from "react-icons/fa";
import expertVisionLogo from "../../assets/images/EXPERT VISION_Amarelo e Branco_Cut.png";
import "./Admin.css";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/admin/dashboard");
    } catch (err) {
      console.error("Login error:", err);
      setError("Credenciais inválidas. Por favor, tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-login-container">
        <div className="admin-login-card">
          <div className="admin-login-header">
            <div className="admin-login-logo-container">
              <img
                src={expertVisionLogo}
                alt="Expert Vision Logo"
                className="admin-login-logo spinning"
                onMouseEnter={(e) =>
                  (e.target.style.animationPlayState = "paused")
                }
                onMouseLeave={(e) =>
                  (e.target.style.animationPlayState = "running")
                }
              />
            </div>
            <p className="admin-login-subtitle">
              Faça login para gerenciar o conteúdo do blog
            </p>
          </div>

          <form onSubmit={handleLogin} className="admin-login-form">
            <div className="admin-login-input-group">
              <div className="admin-login-input-wrapper">
                <FaEnvelope className="admin-login-input-icon" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="E-mail"
                  className="admin-login-input"
                  required
                />
              </div>
            </div>

            <div className="admin-login-input-group">
              <div className="admin-login-input-wrapper">
                <FaLock className="admin-login-input-icon" />
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Senha"
                  className="admin-login-input"
                  required
                />
              </div>
            </div>

            {error && (
              <div className="admin-login-error">
                <FaExclamationCircle />
                <span>{error}</span>
              </div>
            )}

            <button
              type="submit"
              className={`admin-login-button ${loading ? "loading" : ""}`}
              disabled={loading}
            >
              {loading ? (
                <>
                  <div className="admin-login-spinner"></div>
                  <span>Entrando...</span>
                </>
              ) : (
                "Entrar"
              )}
            </button>
          </form>

          <div className="admin-login-footer">
            <p>Expert Vision © {new Date().getFullYear()}</p>
          </div>
        </div>
      </div>
      <SpaceParticles />
    </div>
  );
};

export default AdminLogin;
